<template lang="pug">
  img.img-fluid.img-thumbnail(v-bind:src="screenshotUrl")
</template>

<script>
import Lib from '@/lib'

export default {
  props: {
    screenshotKey: String,
  },
  computed: {
    screenshotUrl: function() {
      const url = new URL(this.screenshotKey, Lib.preset().resourceUrlBase);
      return url.href;
    }
  }
}
</script>